<template>
    <el-dialog
        :title="name"
        :visible.sync="show_modal"
        :close-on-click-modal="false"
        append-to-body
        top="5vh"
        width="90%"
        @closed="$emit('closed')"
    >
        <div class="row" v-if="prospect">
            <div class="col-sm-7" style="display: flex; flex-direction: column; row-gap: 2rem">
                <div>
                    <div v-for="(info, index) in prospect.snippet" :key="index">
                        <span v-if="info.type === 'indeed_profile_url'">
                            Indeed Profile: <a :href="info.value" target="_blank">{{ info.value }}</a><br>
                        </span>
                        <span v-else-if="info.type === 'intelliapp_url'">
                            Intelliapp: <a :href="info.value" target="_blank">{{ info.value }}</a><br>
                        </span>
                        <span v-else>
                            {{ info.value }}<br>
                        </span>
                    </div>
                </div>

                <el-tabs v-model="activeTab" type="border-card">
                    <el-tab-pane :label="'Job Posts (' + prospect.jobs.length + ')'" name="jobs">
                        <div style="max-height: 60vh; overflow-y: auto">
                            <table class="table table-striped table-hover table-sticky-header custom-table">
                                <thead>
                                    <tr>
                                        <th style="width: 60%">Title</th>
                                        <th style="width: 30%">Locations</th>
                                        <th>Site</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(job, index) in prospect.jobs" :key="index">
                                        <td>
                                            {{ job.title }}<br>
                                            <small><a :href="job.post_url" target="_blank">{{ job.post_url }}</a></small>
                                        </td>
                                        <td><small>{{ job.location }}</small></td>
                                        <td>{{ job.source_friendly }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="'Contacts (' + prospect.contacts.length + ')'" name="contacts">
                        <div style="max-height: 60vh; overflow-y: auto">
                            <table class="table table-striped table-hover table-sticky-header custom-table">
                                <thead>
                                    <tr>
                                        <th>Name / Title</th>
                                        <th>Phone</th>
                                        <th>Email</th>
                                        <th>Source</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(contact, index) in prospect.contacts" :key="index">
                                        <td>
                                            {{ contact.name }}
                                            <i v-if="contact.title"><br>{{ contact.title }}</i>
                                        </td>
                                        <td>{{ contact.phone }}</td>
                                        <td>{{ contact.email }}</td>
                                        <td>
                                            {{ contact.source }}
                                            <span v-if="contact.lead_source"> ({{ contact.lead_source }})</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            
            <div class="col-sm-5" style="display: flex; flex-direction: column; padding-left: 60px; max-height: 65vh">
                <div>
                    <b>LAST ACTIVITY</b>
                </div>

                <div style="margin-top: 15px; flex-grow: 1; overflow-y: auto">
                    <template v-if="prospect.tasks.length === 0">
                        No activity recorded in Salesforce.
                    </template>
                    <div v-for="(task, index) in prospect.tasks" :key="index" style="display: flex; flex-direction: column; row-gap: 0.25rem; border: 1px solid #ccc;; padding: 8px 16px; margin-bottom: 8px">
                        <div>
                            <small>
                                <i class="fa fa-envelope-o" v-if="task.task_subtype === 'Email'"></i>
                                <i class="fa fa-phone" v-else-if="task.task_subtype === 'Call'"></i>
                                <i class="fa fa-tasks" v-else></i>
                                <span style="margin-left: 5px">{{ task.task_subtype }}</span>
                            </small>
                        </div>
                        <div v-if="task.subject">
                            Subject: {{ task.subject }}
                        </div>
                        <div style="white-space: pre-line">
                            {{ task.description }}
                        </div>
                        <div>
                            <small>{{ task.activity_date }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="show_modal = false">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        prospect_id: {
            type: Number,
            required: true,
        },
        tab: {
            type: String
        }
    },
    data() {
        return {
            prospect: null,
            activeTab: 'jobs',
            loading: true,
            show_modal: true
        };
    },
    computed: {
        name() {
            if(! this.prospect) {
                return "Prospect Detail";
            }

            let name = this.prospect.name;
            if(this.prospect.name_alternate) {
                name += ` / ${this.prospect.name_alternate}`;
            }
            return name;
        },
    },
    methods: {
        refresh() {
            return axios.get(url(`admin/prospects/${this.prospect_id}/data`))
                .then((response) => {
                    this.prospect = response.data.prospect;
                    this.resetActiveTab();
                });
        },
        resetActiveTab() {
            if(this.tab) {
                this.activeTab = this.tab;
                return;
            }
            if(this.prospect.jobs.length === 0) {
                this.activeTab = 'contacts';
            }
        },
    },
    mounted() {
        this.refresh();
    }
}
</script>